import { createIconComponent } from '../../factory/create-icon-component';
export const ListColumnIcon = createIconComponent(
  'ListColumnIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.75 3.75C9.75 4.85457 8.85457 5.75 7.75 5.75C6.64543 5.75 5.75 4.85457 5.75 3.75C5.75 2.64543 6.64543 1.75 7.75 1.75C8.85457 1.75 9.75 2.64543 9.75 3.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.75 11.75C9.75 12.8546 8.85457 13.75 7.75 13.75C6.64543 13.75 5.75 12.8546 5.75 11.75C5.75 10.6454 6.64543 9.75 7.75 9.75C8.85457 9.75 9.75 10.6454 9.75 11.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.75 19.75C9.75 20.8546 8.85457 21.75 7.75 21.75C6.64543 21.75 5.75 20.8546 5.75 19.75C5.75 18.6454 6.64543 17.75 7.75 17.75C8.85457 17.75 9.75 18.6454 9.75 19.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.75 11.75C17.75 12.8546 16.8546 13.75 15.75 13.75C14.6454 13.75 13.75 12.8546 13.75 11.75C13.75 10.6454 14.6454 9.75 15.75 9.75C16.8546 9.75 17.75 10.6454 17.75 11.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.75 19.75C17.75 20.8546 16.8546 21.75 15.75 21.75C14.6454 21.75 13.75 20.8546 13.75 19.75C13.75 18.6454 14.6454 17.75 15.75 17.75C16.8546 17.75 17.75 18.6454 17.75 19.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.75 3.75C17.75 4.85457 16.8546 5.75 15.75 5.75C14.6454 5.75 13.75 4.85457 13.75 3.75C13.75 2.64543 14.6454 1.75 15.75 1.75C16.8546 1.75 17.75 2.64543 17.75 3.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
